import React, { useContext, useEffect, useRef } from 'react';
import { MyContext } from '../context/AppContext';

const CartCleaner = () => {
  const { cleanCart } = useContext(MyContext);
  const hasCleaned = useRef(false);

  useEffect(() => {
    // Solo limpiar una vez al montar el componente
    if (!hasCleaned.current) {
      cleanCart();
      hasCleaned.current = true;
    }
  }, [cleanCart]);

  // Este componente no renderiza nada, solo ejecuta la limpieza
  return null;
};

export default CartCleaner; 